import { render, staticRenderFns } from "./Mind.vue?vue&type=template&id=3a8f192b&scoped=true"
import script from "./Mind.vue?vue&type=script&lang=js"
export * from "./Mind.vue?vue&type=script&lang=js"
import style0 from "./Mind.vue?vue&type=style&index=0&id=3a8f192b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8f192b",
  null
  
)

export default component.exports